import script from "./headers.vue?vue&type=script&setup=true&lang=js"
export * from "./headers.vue?vue&type=script&setup=true&lang=js"

import "./headers.vue?vue&type=style&index=0&id=7648683c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7648683c"]])

export default __exports__